var _rect, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPatientLogoAbnormal = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 50,
  height: 50,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 50,
  height: 50,
  fill: "#FFEAEB",
  rx: 10
})), /*#__PURE__*/React.createElement("mask", {
  id: "PatientLogoAbnormal_svg__a",
  width: 26,
  height: 26,
  x: 12,
  y: 12,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M12 12h26v26H12z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#PatientLogoAbnormal_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "red",
  d: "m25 26.517 3.142 3.142q.298.297.758.298.46 0 .759-.298.297-.299.298-.759 0-.46-.298-.758L26.517 25l3.142-3.141q.297-.299.298-.759 0-.46-.298-.758a1.03 1.03 0 0 0-.759-.298q-.46 0-.758.298L25 23.484l-3.141-3.142a1.03 1.03 0 0 0-.759-.298q-.46 0-.758.298a1.03 1.03 0 0 0-.298.758q0 .46.298.759L23.484 25l-3.142 3.142a1.03 1.03 0 0 0-.298.758q0 .46.298.759.298.297.758.298.46 0 .759-.298zm0 9.317q-2.247 0-4.225-.854a10.9 10.9 0 0 1-3.44-2.315 10.9 10.9 0 0 1-2.315-3.44A10.55 10.55 0 0 1 14.167 25q0-2.247.853-4.225a10.9 10.9 0 0 1 2.316-3.44 10.9 10.9 0 0 1 3.44-2.315A10.55 10.55 0 0 1 25 14.167q2.248 0 4.225.853a10.9 10.9 0 0 1 3.44 2.316 10.9 10.9 0 0 1 2.316 3.44q.852 1.976.853 4.224 0 2.248-.854 4.225a10.9 10.9 0 0 1-2.315 3.44 10.9 10.9 0 0 1-3.44 2.316 10.55 10.55 0 0 1-4.225.853m0-2.167q3.63 0 6.148-2.519 2.52-2.518 2.519-6.148t-2.519-6.148T25 16.334q-3.629 0-6.148 2.518-2.518 2.52-2.518 6.148 0 3.63 2.518 6.148 2.52 2.52 6.148 2.519"
}))));
export default SvgPatientLogoAbnormal;